/**
 * Ethoca program state for an app, exposed by phaser on the app JSON
 * (`ethoca.status`: active / disabled / not_provisioned).
 *
 * The Banking tab shows for provisioned apps — including disabled ones, so merchants
 * can always re-enable (product decision on BILL-2356: CTAs stay visible when off).
 * not_provisioned apps have no Ethoca program to manage; activation is Recurly-side.
 */
export const ethocaProvisioned = app => ["active", "disabled"].includes(app?.ethoca?.status);